import { render, staticRenderFns } from "./SupplierCostsTable.vue?vue&type=template&id=70e8765e&scoped=true&"
import script from "./SupplierCostsTable.vue?vue&type=script&lang=js&"
export * from "./SupplierCostsTable.vue?vue&type=script&lang=js&"
import style0 from "./SupplierCostsTable.vue?vue&type=style&index=0&id=70e8765e&scoped=true&lang=css&"
import style1 from "./SupplierCostsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e8765e",
  null
  
)

export default component.exports